import { useState } from 'react';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';

const useGreenfyAI = () => {
  const [showModalCommandSuggestions, setShowModalCommandSuggestions] =
    useState<boolean>(false);
  const [showModalCommandMostUsed, setShowModalCommandMostUsed] =
    useState<boolean>(false);
  const [showModalGreenfyWhatCanYouDo, setShowModalGreenfyWhatCanYouDo] =
    useState<boolean>(false);

  const { isMobile } = useWindowSizes();

  const [stepCurrent, setStepCurrent] = useState<number>(0);
  const [prompt, setPrompt] = useState<string>('');

  const handleShowModalCommandSuggestions = () => {
    setShowModalCommandSuggestions((prevState) => !prevState);
  };

  const handleShowModalCommandMostUsed = () => {
    setShowModalCommandMostUsed((prevState) => !prevState);
  };
  const handleShowModalGreenfyWhatCanYouDo = () => {
    setShowModalGreenfyWhatCanYouDo((prevState) => !prevState);
  };

  const handleAllShowToFalse = () => {
    setShowModalCommandSuggestions(false);
    setShowModalCommandMostUsed(false);
  };
  const handleSetPrompt = (promptStr: string) => {
    setPrompt(promptStr);
  };

  const handleStepCurrent = (current: number) => {
    setStepCurrent(current);
  };

  const handleShowModal = (id?: number) => {
    switch (id) {
      case 0:
        handleShowModalCommandSuggestions();
        break;
      case 1:
        handleShowModalGreenfyWhatCanYouDo();
        break;
      case 2:
        handleShowModalCommandMostUsed();
        break;
      default:
        handleAllShowToFalse();
    }
  };

  const paddingLeft = isMobile ? 0 : 20;

  return {
    showModalCommandSuggestions,
    showModalCommandMostUsed,
    stepCurrent,
    prompt,
    showModalGreenfyWhatCanYouDo,
    paddingLeft,

    handleShowModal,
    handleSetPrompt,
    handleStepCurrent,
    handleShowModalGreenfyWhatCanYouDo,
  };
};
export default useGreenfyAI;
